const apiUrl = () => {
  switch (window.TAPPY_ENV) {
    case 'staging':
      return 'https://api-staging.np.dealshield.com/graphql';
    case 'qa':
      return 'https://api-qa.np.dealshield.com/graphql';
    case 'production':
      return 'https://api.dealshield.com/graphql';
    case 'development':
      return process.env.REACT_APP_API_URL;
    default:
      return process.env.REACT_APP_API_URL;
  }
};

const API_URL = apiUrl();

// With HashRouter the query string lives inside window.location.hash (e.g. #/path?GUARANTEES=true),
// not in window.location.search, so we parse from the hash fragment.
const _hashQuery = window.location.hash.includes('?')
  ? window.location.hash.split('?')[1]
  : window.location.search.slice(1);

const _guaranteesQueryParam = new URLSearchParams(_hashQuery).get('GUARANTEES');
export const GUARANTEES_V2_ENABLED = _guaranteesQueryParam !== null
  ? _guaranteesQueryParam === 'true'
  : process.env.REACT_APP_GUARANTEES_V2_ENABLED === 'true';

// With HashRouter the query string lives inside window.location.hash (e.g. #/path?ElEng=true),
// not in window.location.search, so we parse from the hash fragment.
const _eligibilityEngineQueryParam = new URLSearchParams(_hashQuery).get(
  'ElEng'
);
export const ELIGIBILITY_ENGINE_ENABLED = _eligibilityEngineQueryParam !== null
  ? _eligibilityEngineQueryParam === 'true'
  : process.env.REACT_APP_ELIGIBILITY_ENGINE_ENABLED === 'true';

// With HashRouter the query string lives inside window.location.hash (e.g. #/path?MULTI_SUBSCRIPTION=true),
// not in window.location.search, so we parse from the hash fragment.
const _multiSubscriptionQueryParam = new URLSearchParams(_hashQuery).get(
  'MULTI_SUBSCRIPTION'
);
export const MULTI_SUBSCRIPTION_ENABLED = _multiSubscriptionQueryParam !== null
  ? _multiSubscriptionQueryParam === 'true'
  : process.env.REACT_APP_MULTI_SUBSCRIPTION_ENABLED === 'true' || null;

export default API_URL;
